/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react';
import Head from 'next/head';
import BaseLayout from '@/components/common/BaseLayout';
import CareerPolicy from '@/components/CareerPolicy';
import TAGS from '../../public/headJson.json';
import RouteName from '../utils/route.util';

const CareerServicesPage = () => {
  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.careerServices.title}</title>
        <meta name="title" content={TAGS.careerServices.title} />
        <meta name="description" content={TAGS.careerServices.desc} />
        <link rel="canonical" href={`${RouteName.careerServices}/`} />

        {/* Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={RouteName.careerServices} />
        <meta property="og:title" content={TAGS.careerServices.title} />
        <meta property="og:description" content={TAGS.careerServices.desc} />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.careerServices} />
        <meta property="twitter:title" content={TAGS.careerServices.title} />
        <meta property="twitter:description" content={TAGS.careerServices.desc} />
      </Head>
      <BaseLayout category={undefined}>
        <CareerPolicy />
      </BaseLayout>
    </>
  );
};

export default CareerServicesPage;
